import { render, staticRenderFns } from "./CreatePtLockBtn.vue?vue&type=template&id=1388d239&"
import script from "./CreatePtLockBtn.vue?vue&type=script&lang=js&"
export * from "./CreatePtLockBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports